import { SxProps } from '@mui/material';

import { themeColors } from '@/config/theme/themeColors.ts';

export const LogoStyles: SxProps = {
  background: themeColors.white,
  height: '36px',
};
